module.exports = __webpack_public_path__ + "img/aaron.f941312b.jpg";